
define('text!libs/strand/src/strand-button/example.html',[],function () { return '<strand-button type="secondary">\n\t<label>button title here</label>\n</strand-button>\n<strand-button type="primary">\n\t<label>button title here</label>\n</strand-button>\n<strand-button type="primary" fitparent>\n\t<label>button title here</label>\n</strand-button>';});

